/* XTTC SHOP — theme behaviour.
   No dependencies, no build step. Same rule as the label site: it has to
   still work in three years. Everything here degrades to plain HTML if JS
   never runs — the product form posts normally, the nav is real links. */
(function () {
  'use strict';

  /* ---------------------------------------------------------- nav drawer */
  var burger = document.querySelector('[data-burger]');
  var drawer = document.querySelector('[data-drawer]');
  if (burger && drawer) {
    var setDrawer = function (open) {
      drawer.setAttribute('data-open', open ? 'true' : 'false');
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.documentElement.classList.toggle('drawer-open', open);
    };
    burger.addEventListener('click', function () {
      setDrawer(drawer.getAttribute('data-open') !== 'true');
    });
    drawer.addEventListener('click', function (e) {
      if (e.target.closest('a') || e.target.closest('[data-drawer-close]')) setDrawer(false);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') setDrawer(false);
    });
  }

  /* ------------------------------------------------------- quantity boxes */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-qty]');
    if (!b) return;
    var input = b.parentNode.querySelector('input');
    if (!input) return;
    var min = parseInt(input.getAttribute('min') || '1', 10);
    var next = (parseInt(input.value, 10) || min) + (b.getAttribute('data-qty') === 'up' ? 1 : -1);
    input.value = Math.max(min, next);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ------------------------------------------------------------- currency */
  function money(cents, format) {
    var f = format || '€{{amount_with_comma_separator}}';
    var value = (cents / 100);
    function withDelims(v, thousands, decimal) {
      var parts = v.toFixed(2).split('.');
      var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return whole + decimal + parts[1];
    }
    return f.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, name) {
      switch (name) {
        case 'amount': return withDelims(value, ',', '.');
        case 'amount_no_decimals': return Math.round(value).toLocaleString('en-US');
        case 'amount_with_comma_separator': return withDelims(value, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return Math.round(value).toLocaleString('de-DE');
        case 'amount_with_apostrophe_separator': return withDelims(value, "'", '.');
        default: return withDelims(value, ',', '.');
      }
    });
  }

  /* -------------------------------------------------------- variant picker
     Reads the variant array Shopify renders into the page, matches the
     checked option radios against it, and updates price, the hidden
     variant id, the button state and the URL. */
  document.querySelectorAll('[data-variants]').forEach(function (root) {
    var dataEl = root.querySelector('[data-variant-json]');
    if (!dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (err) { return; }

    var idInput = root.querySelector('[data-variant-id]');
    var priceEl = root.querySelector('[data-price]');
    var addBtn = root.querySelector('[data-add]');
    var format = root.getAttribute('data-money-format') || '';
    var soldOut = root.getAttribute('data-sold-out') || 'Sold out';
    var addLabel = root.getAttribute('data-add-label') || 'Add to cart';
    var saleLabel = root.getAttribute('data-sale-label') || 'Sale';

    function chosen() {
      return Array.prototype.map.call(root.querySelectorAll('[data-option-index]'), function (group) {
        var checked = group.querySelector('input:checked');
        return checked ? checked.value : null;
      });
    }

    function update() {
      var picked = chosen();
      var match = variants.filter(function (v) {
        return picked.every(function (val, i) { return val === null || v.options[i] === val; });
      })[0];

      // reflect the choice back into the labels
      root.querySelectorAll('[data-option-index]').forEach(function (group) {
        var out = group.querySelector('[data-option-selected]');
        var checked = group.querySelector('input:checked');
        if (out && checked) out.textContent = checked.value;
      });

      /* Grey out the values that can't be bought given everything else that's
         picked. On a single-option product this matches what Liquid already
         rendered; on a multi-option one it narrows as you choose. */
      root.querySelectorAll('[data-option-index]').forEach(function (group) {
        var gi = parseInt(group.getAttribute('data-option-index'), 10);
        group.querySelectorAll('input[type="radio"]').forEach(function (input) {
          var possible = variants.some(function (v) {
            if (v.options[gi] !== input.value) return false;
            return picked.every(function (val, i) {
              return i === gi || val === null || v.options[i] === val;
            }) && v.available;
          });
          var label = input.closest('.swatch');
          if (label) label.classList.toggle('swatch--soldout', !possible);
          input.setAttribute('data-available', possible ? 'true' : 'false');
        });
      });

      if (!match) {
        if (addBtn) { addBtn.disabled = true; addBtn.textContent = soldOut; }
        return;
      }

      if (idInput) idInput.value = match.id;

      if (priceEl) {
        var html = '';
        if (match.compare_at_price && match.compare_at_price > match.price) {
          html = '<s>' + money(match.compare_at_price, format) + '</s>' +
                 '<span class="on-sale">' + money(match.price, format) + '</span>' +
                 '<span class="price__note">' + saleLabel + '</span>';
        } else {
          html = money(match.price, format);
        }
        priceEl.innerHTML = html;
      }

      if (addBtn) {
        addBtn.disabled = !match.available;
        addBtn.textContent = match.available ? addLabel : soldOut;
      }

      // swap the gallery to the variant's own image, if it has one
      if (match.featured_image && match.featured_image.id) {
        var target = root.ownerDocument.querySelector('[data-media-id="' + match.featured_image.id + '"]');
        if (target && target.scrollIntoView) {
          var gallery = target.closest('.gallery');
          if (gallery && gallery.firstElementChild !== target) {
            gallery.insertBefore(target, gallery.firstElementChild);
          }
        }
      }

      if (history.replaceState && match.id) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', match.id);
        history.replaceState({}, '', url.toString());
      }
    }

    root.addEventListener('change', function (e) {
      if (e.target.matches('input[type="radio"]')) update();
    });
    update();
  });

  /* ------------------------------------------------------- sort / filters */
  document.querySelectorAll('[data-auto-submit]').forEach(function (el) {
    el.addEventListener('change', function () {
      var form = el.closest('form');
      if (form) form.submit();
    });
  });

  /* ---------------------------------------------------------- cart page
     Quantity changes and removals post the real Shopify cart form, so the
     page works with JS off. With JS on we just submit on change. */
  document.querySelectorAll('[data-cart-form] input[name^="updates"]').forEach(function (input) {
    input.addEventListener('change', function () {
      var form = input.closest('form');
      if (form) form.submit();
    });
  });
})();
